import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.password[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.password[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectSetPasswordLoading = isLoadingSelector('setPasswordStatus');
export const selectSetPasswordFailed = isFailedSelector('setPasswordStatus');

export const selectForgotPasswordLoading = isLoadingSelector('forgotPasswordStatus');
export const selectForgotPasswordFailed = isFailedSelector('forgotPasswordStatus');

export const selectChangePasswordLoading = isLoadingSelector('changePasswordStatus');
export const selectChangePasswordFailed = isFailedSelector('changePasswordStatus');
